import { SignInOption } from '~/modules/sign-in/types/sign-in-option.type';
import { SignInService } from '../feature-sign-in/sign-in.service';

export class SignInOptionsService {
  static $inject = ['SignInService'];

  constructor(private signInService: SignInService) {}

  public optionIsPassword(option: SignInOption): boolean {
    return option.saml === false && option.name === 'Password';
  }

  public getAndSortOverflowOptions(options: Array<SignInOption>): Array<SignInOption> {
    return options
      .filter((option) => option.default !== true)
      .sort((option) => {
        if (option.name === 'Password' && option.saml === false) {
          return -1;
        } else {
          return 1;
        }
      });
  }

  public getOptionsForOrganization(stateParams) {
    // the signinOptionsAPI requires an email, else it errors. So in the case that the params have no email
    // use a generic gmail email address to get the default claimed domains sign in options
    const email = stateParams.auth_email ? stateParams.auth_email : 'user@gmail.com';
    return this.signInService.getSignInOptions(email);
  }
}
